import { render } from "./KioskLogin.vue?vue&type=template&id=648116bf&scoped=true"
import script from "./KioskLogin.vue?vue&type=script&lang=js"
export * from "./KioskLogin.vue?vue&type=script&lang=js"

import "./KioskLogin.vue?vue&type=style&index=0&id=648116bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648116bf"]])

export default __exports__